<template>
  <div class="app-wrapper" :class="classObj">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div>
    <LogoView @handleFeedback="handleFeedback"></LogoView>
    <FeedBack ref="feedback" :dialogFormVisible="dialogFormVisible" @cancleFeedback='cancleFeedback'></FeedBack>
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <div v-if="topNav">
        <navbar ></navbar>
      </div>
      <!--<tags-view></tags-view>-->
      <app-main></app-main>
    </div>
  </div>
</template>


<script>
import { Navbar, Sidebar, AppMain, TagsView, LogoView} from './components'
import FeedBack from './components/FeedBack'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  data(){
    return{
      dialogFormVisible:false
    }
  },
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    LogoView,
    FeedBack
  },
  mixins: [ResizeMixin],
  computed: {
    topNav(){
      return this.$store.state.app.topNav
    },
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  mounted(){
    let _this = this;
    _this.getSystemTime()
  },
  methods: {
     handleFeedback(){
          this.dialogFormVisible=true
        },
      cancleFeedback(){
        this.dialogFormVisible=false
        this.$refs.feedback.resetForm()
      },
    handleClickOutside() {
      this.$store.dispatch('closeSideBar', { withoutAnimation: false })
    },
    getSystemTime(){
      let _this = this;
      _this.$store.dispatch('GetSystemTime', "").then((res) => {
        return true;
      }).catch(() => {
        _this.loading = false
      })
      // setInterval(_this.getSystemTime, 60*60*1000);
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  /*.main-container{*/
    /*margin-top: 50px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue